import {
	Component,
	OnInit,
	Input,
	Output,
	ViewEncapsulation,
	EventEmitter,
	AfterContentInit,
	ViewChild,
	ElementRef
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';

@Component({
	selector: 'rbc-top-nav',
	templateUrl: './topnav.component.html',
	styleUrls: ['./topnav.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class TopnavComponent implements OnInit, AfterContentInit {
	showSearch: boolean = false;

	@Input() id: string;
	@Input() fullWidth: boolean = true;
	@Input() logo: string;
	@Input() logoLink: string;
	@Input() logoAlt: string = 'Logo';
	@Input() searchPlaceholder: string;

	@Output() onSearch = new EventEmitter();

	@ViewChild('secondaryContainer') secondaryContainer: ElementRef;
	@ViewChild('secondaryLeftRef') secondaryLeftRef: ElementRef;
	@ViewChild('secondaryRef') secondaryRef: ElementRef;
	@ViewChild('customSearchRef') customSearchRef: ElementRef;
	@ViewChild('searchRef') searchRef: ElementRef;

	constructor(private idService: IdService) {}

	ngOnInit() {
		this.showSearch = this.onSearch.observers.length > 0;
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	ngAfterContentInit() {
		const secondaryLeftPresent = this.secondaryLeftRef.nativeElement.children.length;
		const secondaryPresent = this.secondaryRef.nativeElement.children.length;
		const customSearchPresent = this.customSearchRef.nativeElement.children.length;

		if (!secondaryLeftPresent && !secondaryPresent) {
			this.secondaryContainer.nativeElement.remove();
		}

		if (customSearchPresent) {
			this.searchRef.nativeElement.remove();
		}
	}

	onInputSearch(e) {
		this.onSearch.emit(e);
	}
}
